
import Seo from '../components/Seo';
import React from 'react';

const events = [
  { id: 1, title: 'Community Gathering', date: '2025-12-15', description: 'Join us for a community gathering at the Vine Centre.' }
];

function Events() {
  return (
    <section id="events">
      <Seo
        title="Events | Vine Centre Belfast"
        description="See upcoming events at the Vine Centre, North Belfast. Join our community gatherings, workshops, and more."
      />
      <h2>Upcoming Events</h2>
      <ul>
        {events.map(event => (
          <li key={event.id}>
            <strong>{event.title}</strong> <br />
            <span>{event.date}</span>
            <p>{event.description}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Events;
